"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Invoice16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 0V16L12.6399 14.4788L10.3333 16L7.97323 14.4788L5.66667 16L3.30656 14.4788L1 16V0H15ZM13 2H3V12.285L3.29402 12.0912L5.654 13.612L7.96069 12.0912L10.321 13.612L12.6274 12.0912L13 12.331V2ZM8 2.5C7.72386 2.5 7.5 2.72386 7.5 3V3.77483C6.33135 3.96836 5.69953 4.81291 5.69953 5.76C5.69953 7.30019 6.9403 7.58365 7.91314 7.80589C8.54044 7.9492 9.05634 8.06706 9.05634 8.48C9.05634 8.88 8.75117 9.16 8.10563 9.16C7.40141 9.16 6.56808 8.72 6.14554 8.26667L5.5 9.49333C5.98917 10.0054 6.71348 10.3484 7.5 10.4566V11C7.5 11.2761 7.72386 11.5 8 11.5C8.27614 11.5 8.5 11.2761 8.5 11V10.4663C9.78253 10.3111 10.5 9.50425 10.5 8.44C10.5 6.81845 9.18975 6.51939 8.20358 6.2943C7.60852 6.15848 7.13146 6.04959 7.13146 5.69333C7.13146 5.33333 7.48357 5.06667 8.02347 5.06667C8.71596 5.06667 9.3615 5.41333 9.70188 5.81333L10.3005 4.61333C9.83456 4.19433 9.23219 3.86651 8.5 3.76562V3C8.5 2.72386 8.27614 2.5 8 2.5Z", fill: "#597EFF" }));
}
function Invoice16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Invoice16Svg, Object.assign({}, svgProps)));
}
exports.default = Invoice16;
//# sourceMappingURL=Invoice16.js.map